import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const apiClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

// Add response interceptor for 401 handling
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await refreshSession();
                return apiClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export async function getEmergencyFund() {
    const resp = await apiClient.get("/api/emergency-fund");
    return resp.data;
}

export async function setMonthlyExpenses(monthlyExpenses) {
    const resp = await apiClient.put("/api/emergency-fund/monthly-expenses",
        { monthlyExpenses },
        { headers: { "Content-Type": "application/json" } }
    );
    return resp.data;
}
